module.exports = "https://cdn01.riselinkedu.com/assets/images/stamp@3x.49ca7cd.png";